import React, { useState, useEffect } from "react";
import FormBranch from "../../../../components/common/forms/FormBranch";
import CompanySearch from "../../../../components/common/forms/CompanySearch";
import FormButtom from "../../../../components/common/forms/FormButtom";
import FormOtherDetails from "../../../../components/common/forms/FormOtherDetails";
import FormPayment from "../../../../components/common/forms/FormPayment";
import FormUploadDocument from "../../../../components/common/forms/FormUploadDocument";
import MainObjectives from "../../../../components/common/forms/MainObjectives";
import { useForm } from "react-hook-form";
import { useLocation, useParams } from "react-router-dom";
import BanijyaCompanyRegistrationB from "../BanijyaCompanyRegistrationB/BanijyaCompanyRegistrationB";

import {
  banijiya_registration_business_details,
  pvt_details_of_shareholder_v2,
  banijiya_registration_upload_document_v3,
  banijiya_shareholder,
} from "./BanijiyaRegistrationForm";

import Documents from "../../../../components/common/forms/Documents";
import { v4 as uuidv4 } from "uuid";
import DetailsOfShareHolders from "../../../../components/common/forms/DetailsOfShareHolders";
import BackButton from "../../../../components/common/backbutton/BackButton";
import { toast, ToastContainer } from "react-toastify";
import api from "../../../../api/api";
import PrivateCompanyModal from "../../../../components/common/modal/CompanyFeeModal";
import PrivateCompanyRegistration from "../PrivateCompanyRegistration/PrivateCompanyRegistration";

import { useSelector } from "react-redux";
import AdminSearchCustomer from "../../common/AdminSearchCustomer";

const BanijyaCompanyRegistration = () => {
  const { register, handleSubmit } = useForm();
  const [changeForm, setChangeForm] = useState(true);
  const [shareHolders, setShareHolders] = useState([
    {
      ...banijiya_shareholder,
      id: uuidv4(),
    },
  ]);
  const [docsOutput, setDocsOutput] = useState([]);
  const [uploadProof, setUploadProof] = useState("");

  const [paymentRangeList, setPaymentList] = useState([]);

  const { user, isSuccess } = useSelector((state) => state.auth);
  const [userID, setUserId] = useState(null);
  const [amount, setAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [dueAmount, setDueAmount] = useState(null);
  const [paidAmount, setPaidAmount] = useState(null);

  const { state } = useLocation();
  const { slug } = useParams();

  // For amount calculation
  useEffect(() => {
    if (amount > 0) {
      let arr = paymentRangeList.filter((item) => {
        return (
          amount >= parseInt(item.range_start) &&
          amount <= parseInt(item.range_end)
        );
      });
      console.log(arr);

      arr.length > 0 && setTotalAmount(arr[0]?.amount);
    } else {
      setTotalAmount(0);
    }
  }, [amount, paymentRangeList]);

  // getting current user
  useEffect(() => {
    api
      .get("/users/me/")
      .then((response) => {
        setDueAmount(response.due_amount);
      })
      .catch((error) => {});
  }, []);

  // for filtering by company_type and show in Modal
  useEffect(() => {
    api.get('/services/company/registration/service-charges/?company_type=banijya_existing')
    .then(response=> {
        // console.log(response.data)
        setPaymentList(response.data)
    }).catch(error=> {
       console.log(error)
    })
  }, [])





  const handleClick = (datas) => {
    datas.share_holders = shareHolders;

    // popping documents
    let docsLatest = docsOutput;
    // docsLatest.pop();

    datas.documents = docsLatest;
    // console.log(data);

    if (user?.user_type === "CL") {
      const user = JSON.parse(localStorage.getItem("user"));
      datas.user = user.user_id;
    } else {
      console.log("user_id", userID);
      if (userID !== null) {
        datas.user = userID;
      }
    }

    api
      .post("/services/company/", datas)
      .then((response) => {
        toast.success("Data Registered Successfully.");

        let transactions = {
          // payment_mode: "e_wallet",
          amount: paidAmount,
          service_object_id: response.data.registration_id,
          created_by: response.data.registration_id,
          service_object_content_type: response.data.service_content_type_id,
          payment_proof: uploadProof,
          company: response.data.company_id,
          transaction_type: "credit",
        };

        api
          .post("/transactions/", transactions)
          .then((response) => {
            toast.success("Data Registered 2 Successfully.");
          })
          .catch((error) => {
            toast.error("Error in Transaction");
          });
      })
      .catch((err) => {
        // console.log(err);
        toast.error("Data Registration Failed.");
      });
  };

  let data = [];
  // const initialState = {image:"", document_name:""}

  // creating initial state according to the length of documents
  banijiya_registration_upload_document_v3.map((item, i) => {
    data.push({ id: uuidv4(), image: "", document_name: "" });
    return "";
  });

  //  console.log('initial state',data)
  const formChangeA = () => {
    setChangeForm(true);
  };
  const formChangeB = () => {
    setChangeForm(false);
  };

  return (
    <div className="px-10 lg:!px-14">
      <p className=" text-primary-red font-Rakkas mt-7 mb-5 text-center text-xl font-semibold tracking-wide underline md:!text-2xl">
        Banijaya Registration Form
      </p>
      <div className=" w-full flex flex-wrap gap-5 text-center justify-center">
        <div
          onClick={formChangeA}
          className={` font-Laila ${
            changeForm === true
              ? "bg-primary-blue  text-white"
              : "bg-gray-300 text-primary-red"
          } px-3  py-2 cursor-pointer rounded-2xl font-bold`}
        >
          ब्यक्तिगत वा साझेदारी नयाँ ब्यवसाय बाणिज्य विभागमा दर्ताको लागि
        </div>
        <div
          onClick={formChangeB}
          className={` font-Laila ${
            changeForm === false
              ? "bg-primary-blue  text-white"
              : "bg-gray-300 text-primary-red"
          } px-3  py-2 cursor-pointer rounded-2xl font-bold`}
        >
          कम्पनीलाई बाणिज्य विभागमा दर्ताको लागि
        </div>
      </div>
      {
      changeForm === true ? (
        <>
          <BanijyaCompanyRegistrationB />
        </>
      ) :
       (
        <>
          <form>
            <div className="mt-3">
              {(user?.user_type === "ST" || user?.user_type === "AD") && (
                <AdminSearchCustomer setUserId={setUserId} />
              )}
            </div>

            <p className="text-primary-blue text-lg underline my-5">
              1. Company Name Details
            </p>
            <CompanySearch register={register} />
            {/* <ComapanyNameDetails /> */}
            <p className="text-primary-blue text-lg underline my-3">
              2. Others Details
            </p>

            <div className="block">
              <div className="flex items-center gap-5 flex-col md:flex-row">
                {/* <div className="border-primary-blue md:w-[60rem] border font-bold">
              {banijiya_registration.map((item, i) => {
                const { name, validation, ip1, type } = item;

                // console.log(item);
                return (
                  <>
                    <div
                      key={i}
                      className="border-primary-blue flex flex-col border-b md:flex-row"
                    >
                      <p className="text-primary-red px-5 py-2 sm:!w-[300px]">
                        {ip1}
                      </p>
                      <input
                        type={type}
                        className="border-primary-blue w-full border-t py-2 pl-3 outline-none md:border-l"
                        {...register(`${name}`, { required: false })}
                      />
                    </div>
                  </>
                );
              })}
              <div className="text-primary-blue max-w-3xl px-5 py-2 text-center">
                पुँजीको आधारमा तपाईको जम्मा लाग्ने रकम
                <span className="text-red-600">रु.२५,१००।–</span> मात्र
              </div>
            </div> */}
                <div className="border-primary-blue md:w-[60rem] border-2 font-bold">
                  {banijiya_registration_business_details.map((item, i) => {
                    const { name, validation, ip1, type } = item;

                    // console.log(item);
                    return (
                      <div
                        key={i}
                        className="border-primary-blue flex flex-col border-b md:flex-row"
                      >
                        <p className="text-primary-red px-5 py-2 font-Laila md:w-[350px]">
                          {ip1}
                        </p>
                        <input
                          type={type}
                          className="border-primary-blue w-full border-t md:border-t-0 py-2 pl-3 outline-none md:border-l-2  lg:border-l-2"
                          {...register(`${name}`, { required: false,
                            onChange: (e) => {e.target.name === "paid_up_capital" && setAmount(e.target.value)}
                          
                          })}
                        />
                      </div>
                    );
                  })}
                  <div className="text-primary-blue border-t-2 font-Laila max-w-3xl px-5 py-2 text-center">
                    पुँजीको आधारमा तपाईको जम्मा लाग्ने रकम{" "}
                    <span className="text-red-600">रु.{totalAmount}।–</span> मात्र
                  </div>
                </div>
                <div>
                  <div className="border-primary-red font-Laila text-primary-blue w-fit rounded-full text-center border-2 p-2 text-sm md:text-base">
                    Pvt. Ltd. Company दर्ता शुल्क सम्बन्धि पूर्ण जानकारी लिनको
                    लागि यहाँ{" "}
                    <span
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModalEdit"
                      className="text-primary-red cursor-pointer"
                    >
                      Click
                    </span>{" "}
                    गर्नुहोस
                    <PrivateCompanyModal paymentRangeList={paymentRangeList} />
                  </div>
                </div>
              </div>
              {/* <div className=" text-primary-blue font-bold border-2 border-primary-red md:w-[30%] w-full p-2 my-4 rounded-xl">
              आयात निर्यात गर्ने उद्देश्यले वाणिज्य विभागमा ब्यवसाय दर्ता गर्दा
              लाग्ने शुल्क सम्बन्धि पूर्ण जानकारी लिनको लागि यहाँ{" "}
              <button className="text-red-400">Click</button> गर्नुहोस ।
            </div> */}
            </div>
            <div className="text-primary-blue text-lg mt-6 underline">
              3. Details of Share Holders{" "}
              <span className="text-primary-blue font-Laila underline">
                (शेयर सदस्य तथा साँक्षीहरुको विवरण | प्रा.लि. कम्पनीमा बढिमा १०१
                जना सम्म सदस्य रहन सकिन्छ ।)
              </span>
            </div>
            <div className="">
              <DetailsOfShareHolders
                DetailShareholder={pvt_details_of_shareholder_v2}
                needed_share={banijiya_shareholder}
                setShareHolders={setShareHolders}
                shareHolders={shareHolders}
              />
              <p className="text-primary-blue my-5 text-lg underline">
                4. Main Objectives
                <span className="text-primary-blue font-Laila underline">
                  (कम्पनीले गर्ने मुख्य मुख्य कामहरु सहितको उद्देश्यहरु)
                </span>
              </p>

              {/* share holder details form close */}
            </div>
            <MainObjectives register={register} />
            {/* upload document */}
            <div className="text-primary-blue text-lg mt-6 mb-6 underline">
              5. Upload Documents
              <span className="text-primary-blue underline mx-2 font-Laila ">
                (यो ब्यवसाय दर्ताको लागि आवश्यक पर्ने निम्न कागजपत्रहरु Upload
                गर्नुहोस् ।)
              </span>
            </div>
            <Documents
              documents_data={banijiya_registration_upload_document_v3}
              initialState={data}
              setDocument={setDocsOutput}
            />
            <div className="text-primary-blue text-lg underline my-5">
              6. Working Branch
              <span className="text-primary-blue underline text-base font-Laila mx-2">
                (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन
                शाखा नजिक पर्छ छनोट गर्नुहोस् ।)
              </span>
            </div>
            <FormBranch register={register} />
            <FormButtom />
            <FormPayment
              handleSubmit={handleSubmit}
              handleClick={handleClick}
              setUploadProof={setUploadProof}
              dueAmount = {dueAmount}
              setPaidAmount = {setPaidAmount}
              totalAmount={totalAmount}


            />
          </form>
        </>
      )}
    </div>
  );
};

export default BanijyaCompanyRegistration;
